export default __webpack_public_path__ + "static/media/pytorch.e6c50599.svg";